module.exports = __webpack_public_path__ + "img/logo-fifalotto-white5-camel.57949844.png";